import { THEME_VARIANTS } from 'core/components/theme/theme-variant';
const styles = (theme) => ({
  'dark-tableRowRoot': {
    height: 65,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.colors.light_background
    }
  },
  'dark-tableCellRoot': {
    fontSize: 16,
    color: theme.colors.light_text,
    padding: '4px 12px'
  },
  checkbox: {
    color: theme.themeVariant === THEME_VARIANTS.RESKIN ? theme.colorPalette.beige_75 : '#ccc4b8'
  },
  tableContainer: {
    boxShadow: 'none',
    // a long value scrolls the table instead of being cut off by the card
    overflowX: 'auto',
    color: theme.colors.light_text,
    textAlign: 'center'
  },
  srOnly: {
    position: 'absolute',
    width: 1,
    height: 1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap'
  },
  dateGroupRow: {
    height: 'auto'
  },
  noWrap: {
    whiteSpace: 'nowrap'
  },
  dateGroupHeader: {
    color: theme.colors.light_text,
    fontSize: 14,
    fontWeight: 600,
    padding: '12px 12px 4px 12px',
    textAlign: 'left'
  },
  addIncidentContainer: {
    marginTop: theme.spacing(4)
  },
  // Every header cell, DATE's sortable one included, so they share one size and line box. Doubled class:
  // outranks MUI's head-cell color, as the inline style this replaced did.
  headerCell: {
    '&&': {
      color: theme.colors.light_text,
      opacity: 0.6,
      fontSize: 10,
      cursor: 'pointer'
    }
  },
  tableSortLabelRoot: {
    color: `${theme.colors.light_text} !important`,
    opacity: 0.6,
    '&:hover': {
      color: theme.colors.light_text,
      opacity: 1
    },
    '&:focus': {
      color: theme.colors.light_text
    }
  }
});

export default styles;
